"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "my-profile-page"
  }, [_c('PrivateWall', {
    attrs: {
      "user": _vm.currentUser,
      "feed": _vm.globalFeed,
      "is-owner": true
    },
    on: {
      "back": _vm.goBack,
      "publish": _vm.handlePublish
    }
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];